module.exports = __webpack_public_path__ + "img/users-solid.2ba99aff.svg";